module.exports = __webpack_public_path__ + "img/donbler-logo-icononly.e95ffbb8.svg";